export default __webpack_public_path__ + "static/media/lettuce-background.23d3a98a.jpg";